import { TrackJS } from 'trackjs';

const withErrorMeta = (meta: object = {}, fn: () => void) => {
  Object.entries(meta).forEach(([key, value]) => {
    const metaVal = JSON.stringify(value, null, 2);
    TrackJS.addMetadata(key, metaVal);
  });

  fn();

  Object.keys(meta).forEach((key) => {
    TrackJS.removeMetadata(key);
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const trackError = (error: Error | string | any, meta?: object) => {
  if (TrackJS.isInstalled()) {
    withErrorMeta(meta, () => {
      TrackJS.track(error);
    });
  } else {
    let stack;
    if (typeof error !== 'string' && 'stack' in error) {
      stack = error.stack;
    }

    if (!stack) {
      stack = new Error().stack;
    }
    console.error('Tracking:', error, JSON.stringify(meta, null, 2));
    console.error('Stack:', stack);
  }
};
